<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { useModals } from "@/utils/useModals";
import ProfileUserData from "@/components/profile/ProfileUserData.vue";
import ProfileConfirmation from "@/components/profile/ProfileConfirmation.vue";
import ProfileUserQuestionnare from "@/components/profile/ProfileUserQuestionnare.vue";
import ProfileUserMenu from "@/components/profile/ProfileUserMenu.vue";
import ProfileUser from "@/components/profile/ProfileUser.vue";
import ProfileFilter from "@/components/profile/ProfileFilter.vue";

const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();
const { openModal } = useModals();

const isSubmitApplication = ref(false);

// Анкета принята и можно дополнять меню
const isStatusAcceptedAndExtra = computed(
	() => storeRequests.userData.survey?.status === "accepted" && storeSettings.statusSurveyExtra,
);
// Анкета принята или на модерации показываю профиль с заполненными полями без возможности редактирования
const isStatusShowUserProfile = computed(() => storeRequests.userData.survey);
// const isStatusShowUserProfile = computed(() => storeRequests.userData.survey?.status === "accepted" || storeRequests.userData.survey?.status === "handling");

const submitApplication = () => {
	if(storeSettings.statusSurveyRegistration){
		isSubmitApplication.value = true
	} else {
		openModal("registrationEndonlyAuth", {text: 'Прием заявок завершен.', btn: false});
	}
};

const activeTab = ref(1);
const toggleTab = (id) => {
	if (isStatusAcceptedAndExtra.value) {
		activeTab.value = id;
	}
};

watch(
	() => storeRequests.userData.survey,
	() => {
		if(storeRequests.userData.survey){
			isSubmitApplication.value = true
		}
	})

onMounted(async () => {
	if(storeRequests.userData.survey){
		isSubmitApplication.value = true
	}
});
</script>
<template>
	<section class="profile">
		<div class="container">
			<div class="profile__container">
				<h1 class="profile__title title2 --red">Профиль</h1>
				<div class="profile__confirmation" v-if="!storeRequests.userData.is_verification">
					<ProfileConfirmation />
				</div>
				<div class="profile__user-data">
					<ProfileUserData />
				</div>
				<div class="profile__filter">
					<ProfileFilter
						@submit-application="submitApplication"
						@toggle-tab="toggleTab"
						:is-application="isSubmitApplication"
						:active-tab="activeTab"
						:isStatusAcceptedAndExtra
					/>
				</div>
				<div class="profile__questionnare" v-if="isSubmitApplication">
					<Transition>
						<template v-if="activeTab === 1">
							<!--Таб Заявка на участие -->
							<ProfileUser v-if="isStatusShowUserProfile" />
							<!-- Статус на модерации и принят -->
							<ProfileUserQuestionnare v-else />
							<!-- Подча заявки -->
						</template>
						<ProfileUserMenu v-else @toggle-tab="toggleTab" />
						<!--Таб Подтверждение запуска блюд в заведении -->
					</Transition>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.profile {
	position: relative;
	padding: 5.4rem 0;
	@media (max-width: vars.$x480) {
		padding: 3rem 0 10rem;
	}
}
.profile__container {
}
.profile__title {
	margin-bottom: 4rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 26px;
	}
}
.profile__confirmation {
	margin-bottom: 3rem;
}
.profile__user-data {
	margin-bottom: 6rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 4.6rem;
	}
}
.profile__filter {
	margin-bottom: 3.4rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 2.5rem;
	}
}

.v-enter-active,
.v-leave-active {
	transition: all 0.25s ease-out;
}

.v-enter-from {
	opacity: 0;
	transform: translateY(-20px);
}
.v-leave-to {
	opacity: 0;
	transform: translateY(-20px);
}
</style>
